import _ from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { formatName } from '~/utils';
import { Overlay } from './Overlay';
import { LiveSelector } from '~/components';
import { Container, Row, Col } from 'reactstrap';
import { useGlobalContext } from '~/hooks';

export function AddFriendOverlay( props ) {
  const { swipe } = useGlobalContext();
  const handlePick = useCallback( ( person ) => swipe.send( {
    event     : 'friend-in',
    friendId  : person.id,
  } ), [ swipe ] );
  const query = useMemo( () => {
    return { membershipId : swipe.membership.id };
  }, [ swipe.membership.id ] );
  return (
    <Overlay title="Add Friend" {...props}>
      <Container fluid>
        <Row>
          <Col md="6">
            <LiveSelector
              placeholder="Enter your friend's name"
              service="friends"
              field="name"
              renderItem={formatName}
              onPick={handlePick}
              query={query}
            />
          </Col>
          <Col md="6">
            <p>
              A <b>friend</b> is a child who is a member, but not a part of
              your family membership.  This allows you to sign-in any
              children of other members you may have brought with you.
            </p>
            <p>
              Since they are already members, adding a friend <b>does
              not</b> use a guest pass.
            </p>
            <p>
              Previous friends are listed to the left and can be added
              again by pressing the number next to their name (or by
              selecting them with the arrow keys and then pressing
              <kbd>Enter</kbd>).
            </p>
            <p>
              To add a new friend, just begin typing their name and
              matching member names will be displayed.
            </p>
          </Col>
        </Row>
      </Container>
    </Overlay>
  );
}
